import { ApiRequester } from "../ApiRequester"

interface RequestDataShape {
	id: string
}

export async function profileDeleteApi(payload: RequestDataShape, token: string) {
	const endpoint = "/profile/delete/v1"
	const requester = new ApiRequester<RequestDataShape, void>(endpoint)
	await requester.sendRequest(payload, token)
}
